import { StrictMode, lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import "./index.css";

// The signal-box iPad app at /stn is ANONYMOUS (device token + Info Hub PIN, no SSO), so it mounts
// OUTSIDE the SSO-gated App shell and never calls useCurrentUser / triggers an Entra redirect.
const SignalBoxApp = lazy(() => import("./stn/SignalBoxApp"));
// The function-confirm landing (BP-8) is ANONYMOUS too — reached by an emailed
// signed-token link by someone who may not be an SSO user — so it mounts outside
// the SSO-gated App shell, alongside /stn.
const ActionConfirmPage = lazy(() => import("./pages/action/ActionConfirmPage").then((m) => ({ default: m.ActionConfirmPage })));

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/stn/*" element={<Suspense fallback={null}><SignalBoxApp /></Suspense>} />
        <Route path="/action-confirm/*" element={<Suspense fallback={null}><ActionConfirmPage /></Suspense>} />
        <Route path="/*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
